export default "__VITE_ASSET__x8N4Lric__"